import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { RoutePlannerFormComponent } from '../../route-planner-form.component';
import { eTab } from 'src/app/modules/route-planner/enums/route-planning/tabs/tabs.enums';
import { FormBuilder, FormControl } from '@angular/forms';
import { LocationService } from 'src/app/modules/route-planner/services/location/location.service';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  Observable,
  of,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
  tap,
  timer,
} from 'rxjs';
import {
  eSearchStationsOptions,
  SEARCH_STATIONS_OPTIONS,
} from 'src/app/modules/route-planner/constants/search-stations-options.constants';
import { FormValidators } from 'src/app/@forms/validators/validators';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';
import { StationsAutoCompleteComponent } from './stations-auto-complete/stations-auto-complete.component';
import { FavoriteStation } from 'src/app/modules/route-planner/interfaces/favorites/favorite-station.interface';
import { ScheduleService } from 'src/app/modules/route-planner/services/schedule/schedule.service';
import { SearchStopForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/search-stop-form';
import { SearchStationDetailedResultComponent } from '../../../route-planner-results/results/search-station/search-station-detailed-result/search-station-detailed-result.component';
import { Direction } from '@angular/cdk/bidi';
import {
  ASK_FOR_POI,
  FIND_STATION,
  POI_REQUEST_SENT,
  POINTS_OF_INTEREST,
  SEARCH_BY,
  STATION_DETAILS,
  STATION_NAME_NUMBER_ADDRESS,
  STATION_SEARCH_TYPE_RADIO_GROUP_LABEL,
  STATION_SEARCHING,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { PointOfInterest } from 'src/app/modules/route-planner/interfaces/location/point-of-interest.interface';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { SearchStationsResultsContainerComponent } from 'src/app/modules/route-planner/containers/route-planning/route-planning-results-container/search-stations-results-container/search-stations-results-container.component';
import { AutoCompleteService } from 'src/app/modules/route-planner/services/auto-complete/auto-complete.service';
import { NoResultsComponent } from 'src/app/modules/route-planner/components/route-planner-results/shared/no-results/no-results.component';
import { StopFullData } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';
import { PlannerSurveyOrchestratorService } from 'src/app/modules/route-planner/services/survey/planner-survey-orchestrator.service';

@Component({
    selector: 'app-search-station-form',
    templateUrl: './search-station-form.component.html',
    styleUrls: ['./search-station-form.component.scss'],
    standalone: false
})
export class SearchStationFormComponent
  extends RoutePlannerFormComponent
  implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  private noResultsTimerSub?: Subscription;
  missingSearchSent = false;
  missingSearchSentViaButton = false;

  poiEmptyResults = false;
  askPoiText: string;
  poiRequestSentText: string;

  private readonly initialSearchStationFormValues = {
    searchType: eSearchStationsOptions.STATION,
    stop: null,
    poi: null,
  };


  @Output() toggleSearchButton: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() toogleLoader: EventEmitter<boolean> = new EventEmitter<boolean>();

  pointsOfInterestOptions$: Observable<SelectOption<PointOfInterest>[]> = of(
    []
  );
  searchStationsOptions: Observable<SelectOption<eSearchStationsOptions>[]>;
  eSearchStationsOptions = eSearchStationsOptions;
  // pointsOfInterestOptions: Observable<SelectOption<PointOfInterest>[]> =
  //   this.locationsService.getPointsOfInterest().pipe(
  //     map((pois) =>
  //       pois.data?.map((poi: PointOfInterest) => ({
  //         label: poi.name,
  //         value: poi,
  //       }))
  //     )
  //   );

  isPoisAreEquals = (poi1: PointOfInterest, poi2: PointOfInterest) =>
    !!poi1 && !!poi2 && poi1.id === poi2.id;
  stationSearchingText: string;
  searchByStationLabelText: string;
  searchByPoiLabelText: string;
  buttonText: string;
  searchByText: string;
  searchTypeRadioGroupLabel = '';
  direction: Direction;

  test: any;

  // Add these properties to track error state
  hasError: boolean = false;
  errorMessage: string = '';
  // Add this property to track if we've already submitted from a shared URL
  hasSubmittedFromUrl: boolean = false;
  // Add this property to track if we've already submitted from POI URL
  hasSubmittedFromPoiUrl: boolean = false;

  constructor(
    fb: FormBuilder,
    locationService: LocationService,
    queryParamsService: QueryParamsService,
    routePlanningService: RoutePlanningService,
    router: Router,
    utilsService: UtilsService,

    private readonly scheduleService: ScheduleService,
    private readonly languageService: LanguageService,
    private readonly autoCompleteService: AutoCompleteService,
    private readonly plannerSurveyOrchestrator: PlannerSurveyOrchestratorService
  ) {
    super(
      eTab.STATIONS,
      'מצא תחנה',
      fb,
      locationService,
      queryParamsService,
      routePlanningService,
      router,
      utilsService
    );

    this.routePlannerForm = fb.group(
      {
        ...this.routePlannerForm,
        searchType: new FormControl<eSearchStationsOptions>(
          this.initialSearchStationFormValues.searchType
        ),
        stop: new FormControl<Stop>(this.initialSearchStationFormValues.stop, [
          (ctrl) => {
            setTimeout(() => {
              if (
                this.routePlannerForm.controls['searchType'].value ===
                eSearchStationsOptions.STATION
              ) {
                ctrl.updateValueAndValidity({ emitEvent: false });
              }
            });
            return null;
          },
        ]),
        poi: new FormControl<PointOfInterest>(this.initialSearchStationFormValues.poi, [
          (ctrl) => {
            setTimeout(() => {
              if (
                this.routePlannerForm.controls['searchType'].value ===
                eSearchStationsOptions.POI
              ) {
                ctrl.updateValueAndValidity({ emitEvent: false });
              }
            });
            return null;
          },
        ]),
      },
      {
        validators: [FormValidators.validateStopsForm()],
      }
    );
  }

  ngOnInit() {
    this.routePlannerForm.controls['stop'].valueChanges.subscribe((stop) => {
      if (!!stop) {
        this.queryParamsService.setQueryParam('stop', stop.stopcode);
        this.queryParamsService.setQueryParam('poi', null);
      }
    });

    this.routePlannerForm.controls['poi'].valueChanges.subscribe((poi) => {
      if (!!poi) {
        this.queryParamsService.setQueryParam('poi', poi.name);
        this.queryParamsService.setQueryParam('poiId', poi.id);
        this.queryParamsService.setQueryParam('stop', null);
      }
    });

    this.routePlannerForm.controls['searchType'].valueChanges.subscribe(
      (option) => {
        this.queryParamsService.setQueryParam(
          'searchType',
          eSearchStationsOptions[option]
        );

        if (option === eSearchStationsOptions.STATION) {
          this.queryParamsService.setQueryParam('poi', null)
          this.queryParamsService.setQueryParam('poiId', null)
          this.queryParamsService.setQueryParam('poiLat', null)
          this.queryParamsService.setQueryParam('poiLng', null)
          this.routePlannerForm.controls["poi"].patchValue(this.initialSearchStationFormValues.poi)

        } else if (option === eSearchStationsOptions.POI) {
          this.queryParamsService.setQueryParam('stop', null)
          this.routePlannerForm.controls["stop"].patchValue(this.initialSearchStationFormValues.stop)
        }

      }
    );

    this.pointsOfInterestOptions$ = this.routePlannerForm.controls[
      'poi'
    ].valueChanges.pipe(
      tap(() => {
        this.noResultsTimerSub?.unsubscribe();
        this.missingSearchSent = false;
        this.missingSearchSentViaButton = false;
        this.poiEmptyResults = false;
      }),
      debounceTime(AutoCompleteService.AUTO_COMPLETE_DEBOUNCE_TIME),
      distinctUntilChanged(),
      switchMap((poiTerm) =>
        this.autoCompleteService.searchPointsOfInterest(poiTerm)
      ),
      tap((results) => {
        const searchText = this.routePlannerForm.controls['poi'].value;
        const hasText = typeof searchText === 'string' && searchText.length >= AutoCompleteService.AUTO_COMPLETE_MIN_CHAR;
        this.poiEmptyResults = results.length === 0 && hasText;

        if (searchText.length >= AutoCompleteService.AUTO_COMPLETE_MIN_CHAR && this.poiEmptyResults) {
          this.noResultsTimerSub?.unsubscribe();
          this.noResultsTimerSub = timer(3_000).pipe(
            switchMap(() => this.autoCompleteService.addMissingSearch(searchText)),
            takeUntil(this.destroy$)
          ).subscribe(() => {
            this.missingSearchSent = true;
          });
        }
      })
    );
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.stationSearchingText = STATION_SEARCHING[language.language];
      this.searchByStationLabelText =
        STATION_NAME_NUMBER_ADDRESS[language.language];
      this.searchByPoiLabelText = POINTS_OF_INTEREST[language.language];
      this.buttonTitle = FIND_STATION[language.language];
      this.searchByText = SEARCH_BY[language.language];
      this.searchTypeRadioGroupLabel =
        STATION_SEARCH_TYPE_RADIO_GROUP_LABEL[language.language];
      this.askPoiText = ASK_FOR_POI[language.language];
      this.poiRequestSentText = POI_REQUEST_SENT[language.language];

      const searchOptions = [...SEARCH_STATIONS_OPTIONS];
      searchOptions.forEach((option) => {
        switch (option.value) {
          case eSearchStationsOptions.STATION:
            option.label = STATION_DETAILS[language.language];
            break;
          case eSearchStationsOptions.POI:
            option.label = POINTS_OF_INTEREST[language.language];
            break;
          default:
            option.label = STATION_DETAILS[language.language];
        }
      });

      this.searchStationsOptions = of(searchOptions);
    });
  }

  public override submitRoutePlannerForm() {
    if (!!this.routePlannerForm.valid) {
      // Reset error state
      this.hasError = false;
      this.errorMessage = '';

      const formValues = this.routePlannerForm.value as SearchStopForm;
      this.toggleSearchButton.emit(true);
      this.toogleLoader.emit(true);
      switch (formValues.searchType) {
        case eSearchStationsOptions.STATION:
          this.scheduleService
            .getStopFullData(formValues.stop.stopcode)
            .subscribe({
              next: (res) => {
                this.toggleSearchButton.emit(false);
                this.toogleLoader.emit(false);
                this.openStationDetailedResult(res.data, formValues);
              },
              error: (error) => {
                this.toggleSearchButton.emit(false);
                this.toogleLoader.emit(false);

                // Set error state
                this.hasError = true;
                this.errorMessage = `${formValues.stop?.name || ''} (${formValues.stop?.stopcode || ''
                  })`;
              },
            });
          break;

        case eSearchStationsOptions.POI:
          this.scheduleService
            .getStopsCloseToLocation({
              lat: formValues.poi.lat,
              lng: formValues.poi.lng,
            })
            .subscribe({
              next: (res) => {
                this.toggleSearchButton.emit(false);
                this.toogleLoader.emit(false);
                this.openStationsResultsContainer(res.data, formValues);
              },
              error: (error) => {
                this.toggleSearchButton.emit(false);
                this.toogleLoader.emit(false);

                // Set error state
                this.hasError = true;
                this.errorMessage = formValues.poi?.name || 'this location';
              },
            });
          break;

        default:
          break;
      }
    }
  }

  private openStationDetailedResult(stop: StopFullData, formValues: SearchStopForm) {
    if (stop) {
      this.routePlanningService._componentOverlaySub.next({
        componentType: SearchStationDetailedResultComponent,
        data: {
          stop: stop,
          formValues: formValues,
          displayOnMapOverlay: true,
          closeCallbackFn: (closeData: {isLanguageDirectionChanged: boolean}) => {
            if(closeData.isLanguageDirectionChanged) {     
                this.openStationDetailedResult(stop, formValues);
            }
          },
        },
      });
      this.plannerSurveyOrchestrator.scheduleSurveyAfterSearch({
        plannerScenario: 'station',
        stationId: stop.stopcode,
      });
    } else {
      // Set error state for empty results
      this.hasError = true;
      this.errorMessage = `${formValues.stop?.name || ''} (${formValues.stop?.stopcode || ''
        })`;
    }
  }

  private openStationsResultsContainer(stations: StopFullData[], formValues: SearchStopForm) {
    if (!!stations && stations.length > 0) {
      this.routePlanningService._componentOverlaySub.next({
        componentType: SearchStationsResultsContainerComponent,
        data: {
          stations: stations,
          formValues: formValues,
          closeCallbackFn: (isLanguageDirectionChanged: boolean) => {
            if(isLanguageDirectionChanged) {
              this.openStationsResultsContainer(stations, formValues);
            }
          },
        },
      });
      this.plannerSurveyOrchestrator.scheduleSurveyAfterSearch({
        plannerScenario: 'stationPoi',
      });
    } else {
      // Set error state for empty results
      this.hasError = true;
      this.errorMessage = formValues.poi?.name || 'this location';
    }
  }
    
  

  override onTabLeave() {
    this.routePlannerForm.reset(this.initialSearchStationFormValues)
    // Reset submission flags so they can be used again if user returns to this tab
    this.hasSubmittedFromUrl = false;
    this.hasSubmittedFromPoiUrl = false;
  }

  override autofillQueryParams() {
    const queryParams = this.queryParamsService.currentParams;
    const searchType = queryParams['searchType'];
    const stopCode = queryParams['stop'];
    const poiName = queryParams['poi'];
    const poiId = queryParams['poiId'];
    const poiLat = queryParams['poiLat'];
    const poiLng = queryParams['poiLng'];
    const poiSelectedIndex = queryParams['poiSelectedIndex']
      ? parseInt(queryParams['poiSelectedIndex'])
      : null;

    // Handle POI parameters from shared link
    if (poiName && poiLat && poiLng) {
      // Use emitEvent: false to prevent triggering valueChanges subscriptions
      this.routePlannerForm.patchValue({
        searchType: eSearchStationsOptions.POI,
        poi: {
          name: poiName,
          lat: parseFloat(poiLat),
          lng: parseFloat(poiLng),
          id: poiId,
        },
      }, { emitEvent: false });

      // Update query parameters manually since we disabled events
      this.queryParamsService.setQueryParam('searchType', eSearchStationsOptions[eSearchStationsOptions.POI]);
      this.queryParamsService.setQueryParam('poi', poiName);
      this.queryParamsService.setQueryParam('poiLat', poiLat);
      this.queryParamsService.setQueryParam('poiLng', poiLng);
      this.queryParamsService.setQueryParam('stop', null);

      // Automatically submit the form if we have all required POI data and haven't submitted yet
      if (!this.hasSubmittedFromPoiUrl) {
        this.hasSubmittedFromPoiUrl = true;
        this.submitRoutePlannerForm();

      }
      return;
    }

    // Handle station parameter - always process this the same way regardless of searchType
    if (stopCode) {
      // Always set searchType to STATION when stop parameter is present
      // Use emitEvent: false to prevent triggering valueChanges subscriptions
      this.routePlannerForm.patchValue({
        searchType: eSearchStationsOptions.STATION,
      }, { emitEvent: false });

      const stop = parseInt(stopCode);
      if (!isNaN(stop)) {
        this.scheduleService.getStopByCode(stop).subscribe((res) => {
          if (!!res.data) {
            this.routePlannerForm.patchValue({ stop: res.data }, { emitEvent: false });
            // Always submit when there's a stop code in the URL
            // This is needed for station sharing to work
            if (!this.hasSubmittedFromUrl) {
              this.hasSubmittedFromUrl = true;
              setTimeout(() => {
                this.submitRoutePlannerForm();
              }, 100);
            }
          }
        });
      }
      return;
    }

    // Handle other cases where searchType is specified but no stop or POI
    if (!!searchType && !stopCode && !poiName) {
      // Use emitEvent: false to prevent triggering valueChanges subscriptions
      this.routePlannerForm.patchValue({
        searchType: eSearchStationsOptions[searchType],
      }, { emitEvent: false });

      // Handle POI by ID (original implementation)
      if (searchType === eSearchStationsOptions[eSearchStationsOptions.POI] && queryParams['poi']) {
        const poi = parseInt(queryParams['poi']);

        if (!!poi) {
          this.locationsService
            .getPointOfInterestById(poi)
            .subscribe((response: ServiceResponse<PointOfInterest>) => {
              if (response.data) {
                this.routePlannerForm.patchValue({ poi: response.data }, { emitEvent: false });
              }
            });
        }
      }
    }
  }

  override openAutocomplete(
    stopFormControl: FormControl<Stop>,
    title: string,
    queryParam: string
  ) {
    this.routePlanningService._componentOverlaySub.next({
      componentType: StationsAutoCompleteComponent,
      data: {
        title: title,
        queryParam: queryParam,
        station: stopFormControl.value,
        saveResultToStorage: true,
        closeCallbackFn: (stop: Stop) => {
          if (!!stop) {
            stopFormControl.setValue(stop);

            if (!!queryParam) {
              this.queryParamsService.setQueryParam(queryParam, stop.stopcode);
            }
          }
        },
      },
    });
  }

  handleFavoriteStationClick(favoriteStation: FavoriteStation) {
    this.routePlannerForm.patchValue({ stop: favoriteStation });
    this.submitRoutePlannerForm()
  }

  sendMissingSearch(): void {
    const searchText = this.routePlannerForm.controls['poi'].value;
    if (typeof searchText !== 'string') return;
    this.missingSearchSentViaButton = true;
    if (this.missingSearchSent) {
      return;
    }
    this.noResultsTimerSub?.unsubscribe();
    this.autoCompleteService.addMissingSearch(searchText)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.missingSearchSent = true;
      });
  }

  ngOnDestroy(): void {
    this.noResultsTimerSub?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPoiSub(poi: PointOfInterest): string {

    let sub = ""
    if (poi.addressDetails.street) {
      sub += poi.addressDetails.street + " "
      if (poi.addressDetails.houseNumber) {
        sub += poi.addressDetails.houseNumber
      }
    }
    if (poi.addressDetails.city) {
      if (poi.addressDetails.street) {
        sub += ", "
      }
      sub += poi.addressDetails.city
    }
    return sub;

  }

  getStopName(): string {
    return this.getFormControl("stop").value?.name[this.languageService.getSelectedLanguage().symbol] || this.getFormControl("stop").value?.name.he || this.getFormControl("stop").value?.name || '';
  }

}
